import request from '@/plugin/ajax.js'
let prefixerForProxy = '/api'
import axios from 'axios'

if (process.env.NODE_ENV === 'development') {
  prefixerForProxy = '/api'
} else {
  if (process.env.VUE_APP_TITLE === 'staging') { // 本地环境
    prefixerForProxy = '/api'
  } else if (process.env.VUE_APP_TITLE === 'alpha') { // 线上测试环境
    prefixerForProxy = ''
  } else if (process.env.VUE_APP_TITLE === 'beta') { // 线上正式环境
    prefixerForProxy = ''
  }
}

const QueryNewsType = () => { // 加载树形新闻类型
  return request({
    url: `${prefixerForProxy}/NewsType/LoadJstreeNodes`,
    method: 'get'
  })
}

const getNewsTypeOptions = () => { // 加载树形新闻类型
  return request({
    url: `${prefixerForProxy}/NewsType/GetOptions`,
    method: 'get'
  })
}

const SaveNewsType = (data) => { // 保存新闻类型
  return request({
    url: `${prefixerForProxy}/NewsType/Save`,
    method: 'post',
    data
  })
}

const DeleteNewsTypeById = (data) => { // 删除新闻类型
  return request({
    url: `${prefixerForProxy}/NewsType/DeleteById`,
    method: 'post',
    data
  })
}

const SelectNewsTypeById = (params) => { // 根据Id查看新闻类型
  return request({
    url: `${prefixerForProxy}/NewsType/SelectById`,
    method: 'get',
    params
  })
}

const SaveNews = (data) => { // 保存新闻
  return request({
    url: `${prefixerForProxy}/News/Save`,
    method: 'post',
    data
  })
}

const QueryNews = (params) => { // 新闻分页查询
  return request({
    url: `${prefixerForProxy}/News/Query`,
    method: 'get',
    params
  })
}

const UpdateNewsTopById = (data) => { // 新闻置顶
  return request({
    url: `${prefixerForProxy}/News/UpdateTopById`,
    method: 'post',
    data
  })
}

const SendNewsBacklog = (data) => { // 新闻送审
  return request({
    url: `${prefixerForProxy}/News/SendBacklog`,
    method: 'post',
    data
  })
}

const RecallNews = (data) => { // 新闻撤回
  return request({
    url: `${prefixerForProxy}/News/Recall`,
    method: 'post',
    data
  })
}

const UpdateNewsStatus = (data) => { // 更新新闻状态
  return request({
    url: `${prefixerForProxy}/News/UpdateStatus`,
    method: 'post',
    data
  })
}

const DeleteNewsById = (data) => { // 删除新闻
  return request({
    url: `${prefixerForProxy}/News/DeleteById`,
    method: 'post',
    data
  })
}

const QuerySiteMenu = (params) => { // 加载站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/LoadJsTreeNodes`,
    method: 'get',
    params
  })
}

const QueryDomainPrefix = (params) => { // 查询域名
  return request({
    url: `${prefixerForProxy}/News/GetDomainPrefix`,
    method: 'get',
    params
  })
}

const DeleteNewsInBatches = (data) => { // 批量删除新闻
  return request({
    url: `${prefixerForProxy}/News/DeleteInBatches`,
    method: 'post',
    data
  })
}

const DeleteSiteMenu = function (data) {//删除站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/DeleteSiteMenu`,
    method: 'post',
    data
  })
}
const SaveSiteMenu = function (data) {//保存站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/SaveSiteMenu`,
    method: 'post',
    data
  })
}
const SavenewMenu = function (data) {//保存新站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/NewMenu`,
    method: 'post',
    data
  })
}
const loadMenuJsTreeNodes = function (params) {//加载站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/LoadJsTreeNodes`,
    method: 'get',
    params
  })
}
const nodeMenuMove = function (data) {//移动站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/NodeMove`,
    method: 'post',
    data
  })
}
const getMenuDir = function (params) {//获取新站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/QueryById`,
    method: 'get',
    params
  })
}
const saveMenuDir = function (data) {//保存新站点菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/SaveSiteMenu`,
    method: 'post',
    data
  })
}
const loadMenuJsTreeChildren=function (params) {//加载站点子菜单
  return request({
    url: `${prefixerForProxy}/SiteMenu/LoadJsTreeChildren`,
    method: 'get',
    params
  })
}
const QueryConnection=function (params) {//加载红十字会管理
  return request({
    url: `${prefixerForProxy}/Connection/Query`,
    method: 'get',
    params
  })
}
const DeleteConnection = function (data) {//删除红十字会
  return request({
    url: `${prefixerForProxy}/Connection/DeleteConnection`,
    method: 'post',
    data
  })
}
const saveConnection = function (data) {//保存红十字会
  return request({
    url: `${prefixerForProxy}/Connection/SaveConnection`,
    method: 'post',
    data
  })
}
const QuerySlideShow=function (params) {//加载轮播图数据
  return request({
    url: `${prefixerForProxy}/SlideShow/Query`,
    method: 'get',
    params
  })
}
const saveSlideShow = function (data) {//保存轮播图
  return request({
    url: `${prefixerForProxy}/SlideShow/SaveSlideShow`,
    method: 'post',
    data
  })
}

const QueryApprovalProcess = function (params) {//查询审核流程
  return request({
    url: `${prefixerForProxy}/ApprovalProcess/Query`,
    method: 'get',
    params
  })
}

const saveApprovalProcess = function (data) {//保存审核流程
  return request({
    url: `${prefixerForProxy}/ApprovalProcess/Save`,
    method: 'post',
    data
  })
}

const QueryApprovalStep = function (params) {//查询审核步骤
  return request({
    url: `${prefixerForProxy}/ApprovalStep/QueryStep`,
    method: 'get',
    params
  })
}

const QueryUsers = function (params) {//查询网络注册用户
  return request({
    url: `${prefixerForProxy}/Users/Query`,
    method: 'get',
    params
  })
}

const UpdateUser = function (data) {//更新网络注册用户状态
  return request({
    url: `${prefixerForProxy}/Users/Update`,
    method: 'post',
    data
  })
}

const DeleteUser = function (data) {//删除网络注册用户
  return request({
    url: `${prefixerForProxy}/Users/DeleteById`,
    method: 'post',
    data
  })
}

const SaveUser = function (data) {//管理员新增用户
  return request({
    url: `${prefixerForProxy}/Users/SaveByAdmin`,
    method: 'post',
    data
  })
}

const ResetUserPassword = function (data) {//管理员重置用户密码
  return request({
    url: `${prefixerForProxy}/Users/ResetPassword`,
    method: 'post',
    data
  })
}

const QueryPersonalMember = function (params) {//查询个人会员信息
  return request({
    url: `${prefixerForProxy}/PersonalMember/Query`,
    method: 'get',
    params
  })
}

const QueryGroupMember = function (params) {//查询团体会员信息
  return request({
    url: `${prefixerForProxy}/GroupMember/Query`,
    method: 'get',
    params
  })
}

const UpdatePersonalMemberStatus = function (data) {//更新个人会员状态
  return request({
    url: `${prefixerForProxy}/PersonalMember/Update`,
    method: 'post',
    data
  })
}

const SavePersonalMember = function (data) {//新增个人会员
  return request({
    url: `${prefixerForProxy}/PersonalMember/Save`,
    method: 'post',
    data
  })
}

const SaveGroupMember = function (data) {//新增团体会员
  return request({
    url: `${prefixerForProxy}/GroupMember/Save`,
    method: 'post',
    data
  })
}

const UpdateGroupMemberStatus = function (data) {//更新团体会员状态
  return request({
    url: `${prefixerForProxy}/GroupMember/Update`,
    method: 'post',
    data
  })
}
const UpdatePaymentstatusPersonal = function (data) {//更新个人会员缴费状态
  return request({
    url: `${prefixerForProxy}/PersonalMember/UpdatePaymentstatus`,
    method: 'post',
    data
  })
}
const UpdatePaymentstatusGroup = function (data) {//更新团体会员缴费状态
  return request({
    url: `${prefixerForProxy}/GroupMember/UpdatePaymentstatus`,
    method: 'post',
    data
  })
}

const QueryPublicWelfare = function (params) {//查询公益项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/Query`,
    method: 'get',
    params
  })
}

const SavePublicWelfare = function (data) {//保存公益项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/Save`,
    method: 'post',
    data
  })
}

const DeletePublicWelfare = function (data) {//删除公益项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/UpdateIsDeleted`,
    method: 'post',
    data
  })
}

const UpdatePublicWelfareStatus = function (data) {//更新公益项目状态
  return request({
    url: `${prefixerForProxy}/PublicWelfare/UpdateStatus`,
    method: 'post',
    data
  })
}

const QueryWelfareIndex = function (params) {//查询公益项目编号
  return request({
    url: `${prefixerForProxy}/PublicWelfare/GetWelfareIndex`,
    method: 'get',
    params
  })
}

const UpdatePublicWelfareIsHelp = function (data) {//更新是否求助项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/UpdateIsHelp`,
    method: 'post',
    data
  })
}

const QueryProjectType = function (params) {//查询公益项目类型
  return request({
    url: `${prefixerForProxy}/PublicWelfare/LoadProjectType`,
    method: 'get',
    params
  })
}

const QueryConnectionName = function (params) {//查询公益项目归属
  return request({
    url: `${prefixerForProxy}/Connection/QueryName`,
    method: 'get',
    params
  })
}

const SavePublicWelfareReview = function (data) {//公益项目送审
  return request({
    url: `${prefixerForProxy}/PublicWelfare/ForReview`,
    method: 'post',
    data
  })
}

const QueryStepById = function (params) {//根据Id查询审核步骤
  return request({
    url: `${prefixerForProxy}/ApprovalStep/QueryStepById`,
    method: 'get',
    params
  })
}

const QueryStepByProcId = function (params) {//根据审批流程Id查询
  return request({
    url: `${prefixerForProxy}/ApprovalStep/QueryStep`,
    method: 'get',
    params
  })
}

const QueryDonation = function (params) {//资金捐赠分页查询
  return request({
    url: `${prefixerForProxy}/Donation/Query`,
    method: 'get',
    params
  })
}

const UpdateContriButionStatus = function (data) {//确认到账
  return request({
    url: `${prefixerForProxy}/Donation/Update`,
    method: 'post',
    data
  })
}

const DeleteContriBution = function (data) {//删除资金捐赠信息
  return request({
    url: `${prefixerForProxy}/Donation/Delete`,
    method: 'post',
    data
  })
}

const QueryTimeToDonationList = function(params) {//定期捐列表查询
  return request({
    url: `${prefixerForProxy}/TimeToDonationList/Query`,
    method: 'get',
    params
  })
}

const QueryTimeToDonation = function(params) {//定期捐用户查询
  return request({
    url: `${prefixerForProxy}/TimeToDonation/Query`,
    method: 'get',
    params
  })
}

const QueryPublicWelfareAll = function (params) {//查询所有公益项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/QueryAll`,
    method: 'get',
    params
  })
}

const SaveContriBution = function (data) {//新增资金捐赠
  return request({
    url: `${prefixerForProxy}/Donation/Save`,
    method: 'post',
    data
  })
}

const QueryDonationMaterials = function (params) {//查询捐物列表
  return request({
    url: `${prefixerForProxy}/DonationMaterials/Query`,
    method: 'get',
    params
  })
}

const QueryMaterialsDetailById = function (params) {//根据Id查询捐物详情
  return request({
    url: `${prefixerForProxy}/DonationMaterials/QueryMaterialsDetailById`,
    method: 'get',
    params
  })
}

const UpdateMaterialsReceiving = function (data) {//物资捐赠确认收货
  return request({
    url: `${prefixerForProxy}/DonationMaterials/IsReceiving`,
    method: 'post',
    data
  })
}

const SaveDonationMateials = function (data) {//保存物资捐赠
  return request({
    url: `${prefixerForProxy}/DonationMaterials/DonationMaterialsSave`,
    method: 'post',
    data
  })
}

const DeleteDonationMaterials = function (data) {//删除物资捐赠
  return request({
    url: `${prefixerForProxy}/DonationMaterials/DeleteById`,
    method: 'post',
    data
  })
}

const QueryInvoiceApply = function (params) {//开票查询
  return request({
    url: `${prefixerForProxy}/InvoiceApply/Query`,
    method: 'get',
    params
  })
}

const UpdateInvoiceApply = function (data) {//确认开票
  return request({
    url: `${prefixerForProxy}/InvoiceApply/Update`,
    method: 'post',
    data
  })
}

const QueryTrainByType = function (params) {//根据活动类型查询
  return request({
    url: `${prefixerForProxy}/Train/QueryByType`,
    method: 'get',
    params
  })
}

const QueryTrainById = function (params) {//根据Id查询活动
  return request({
    url: `${prefixerForProxy}/Train/QueryById`,
    method: 'get',
    params
  })
}

const UpdateTrainStatus = function (data) {//更新活动状态
  return request({
    url: `${prefixerForProxy}/Train/UpdateStatus`,
    method: 'post',
    data
  })
}

const DeleteTrainById = function (data) {//删除活动
  return request({
    url: `${prefixerForProxy}/Train/DeleteById`,
    method: 'post',
    data
  })
}

const SaveTrain = function (data) {//新增活动
  return request({
    url: `${prefixerForProxy}/Train/Save`,
    method: 'post',
    data
  })
}

const ForReviewTrain = function (data) {//培训活动送审
  return request({
    url: `${prefixerForProxy}/Train/ForReview`,
    method: 'post',
    data
  })
}

const QueryLifeGuard = function (params) {//救护员培训报名列表查询
  return request({
    url: `${prefixerForProxy}/TrainApply/QueryLifeGuard`,
    method: 'get',
    params
  })
}

const QueryLifeGuardDetail = function (params) {//救护员培训报名详情查询
  return request({
    url: `${prefixerForProxy}/TrainApply/QueryLifeGuardDetail`,
    method: 'get',
    params
  })
}

const QueryPersonalTrainByApplyId = function (params) {//报名详情查询
  return request({
    url: `${prefixerForProxy}/TrainPerson/QueryByApplyId`,
    method: 'get',
    params
  })
}


const QueryCapitalIncome = function (params) {//查询
  return request({
    url: `${prefixerForProxy}/CapitalIncome/Query`,
    method: 'get',
    params
  })
}

const DeleteIncome = function (data) {//查询
  return request({
    url: `${prefixerForProxy}/CapitalIncome/DeleteCapital`,
    method: 'post',
    data
  })
}

const GetIncomeIndexCapitalIncome = function (params) {//查询
  return request({
    url: `${prefixerForProxy}/CapitalIncome/GetIncomeIndex`,
    method: 'get',
    params
  })
}

const QueryTrainApplyByClassId = function (params) {//根据班级Id以及活动Id查询
  return request({
    url: `${prefixerForProxy}/TrainApply/QueryByClassId`,
    method: 'get',
    params
  })
}

const QueryTrainClassByClass = function (params) {//根据活动Id查询
  return request({
    url: `${prefixerForProxy}/TrainClass/QueryByClass`,
    method: 'get',
    params
  })
}

const SaveTrainClass = function (data) {//新增班级提交人员名单
  return request({
    url: `${prefixerForProxy}/TrainClass/Save`,
    method: 'post',
    data
  })
}

const SaveCapitalIndexCapitalIncome = function (data) {//查询
  return request({
    url: `${prefixerForProxy}/CapitalIncome/SaveCapital`,
    method: 'post',
    data
  })
}

const SaveTrainClassStu = function (data) {//插入报名人员
  return request({
    url: `${prefixerForProxy}/TrainClass/MoveStu`,
    method: 'post',
    data
  })
}

const UpdateTrainClassIsClassed = function (data) {//确认开班
  return request({
    url: `${prefixerForProxy}/TrainClass/UpdateIsClassed`,
    method: 'post',
    data
  })
}

const QuerylifeGuard = function (params) {//查询救护员培训活动中所有报名中的活动
  return request({
    url: `${prefixerForProxy}/Train/QuerylifeGuard`,
    method: 'get',
    params
  })
}

const TransfertoClass = function (data) {//救护培训调班
  return request({
    url: `${prefixerForProxy}/TrainClass/TransferClass`,
    method: 'post',
    data
  })
}

const DeleteTrainClassStu = function (data) {//移除学员
  return request({
    url: `${prefixerForProxy}/TrainClass/DeleteStu`,
    method: 'post',
    data
  })
}

const SaveTrainClassByAutoClass = function (data) {//自动分班
  return request({
    url: `${prefixerForProxy}/TrainClass/AutoClass`,
    method: 'post',
    data
  })
}

const QueryLectureApplyByType = function (params) {//查询讲座报名信息
  return request({
    url: `${prefixerForProxy}/LectureApply/QueryLectureByType`,
    method: 'get',
    params
  })
}

const UpdateLectureIsAttended = function (data) {//公益讲座确认到场
  return request({
    url: `${prefixerForProxy}/LectureApply/UpdateIsAttended`,
    method: 'post',
    data
  })
}

const QueryLibraryPeriods = function (params) {//体验馆预约报名查询
  return request({
    url: `${prefixerForProxy}/LifePeriods/Query`,
    method: 'get',
    params
  })
}

const QueryAllTrainByType = function (params) {//根据类型查询所有活动
  return request({
    url: `${prefixerForProxy}/Train/QueryAllByType`,
    method: 'get',
    params
  })
}

const SaveLibraryPeriods = function (data) {//保存生命体验馆预约报名期数
  return request({
    url: `${prefixerForProxy}/LifePeriods/Save`,
    method: 'post',
    data
  })
}

const QueryLifeApplyByPeriods = function (params) {//根据期数查询生命体验馆预约信息
  return request({
    url: `${prefixerForProxy}/LifeApply/GetLifeApplyByPeriods`,
    method: 'get',
    params
  })
}

const QueryLifeApplyCount = function (params) {//查询生命体验馆总人数
  return request({
    url: `${prefixerForProxy}/LifeApply/QueryCount`,
    method: 'get',
    params
  })
}

const QueryLifePersonByApplyId = function (params) {//通过申请Id查询生命体验馆详情
  return request({
    url: `${prefixerForProxy}/LifePerson/QueryByApplyId`,
    method: 'get',
    params
  })
}

const UpdateLifePersonIsAttended = function (data) {//生命体验馆确定到场
  return request({
    url: `${prefixerForProxy}/LifePerson/UpdateIsAttended`,
    method: 'post',
    data
  })
}

const UpdateLifePersonIsAttendedByApplyId = function (data) {
  return request({
    url: `${prefixerForProxy}/LifePerson/UpdateIsAttendedByApplyId`,
    method: 'post',
    data
  })
}

const QueryBigSickApply = function (params) {//大病申请查询
  return request({
    url: `${prefixerForProxy}/BigSickApply/Query`,
    method: 'get',
    params
  })
}

const QuerySeekHelpApply = function (params) {//其他救助申请查询
  return request({
    url: `${prefixerForProxy}/SeekHelpApply/Query`,
    method: 'get',
    params
  })
}

const SaveSickGrant = function (data) {//保存财政拨款
  return request({
    url: `${prefixerForProxy}/SickGrant/Save`,
    method: 'post',
    data
  })
}

const AddExpendCapitalExpenditure = function (data) {//大病申请查询
  return request({
    url: `${prefixerForProxy}/CapitalExpenditure/AddExpend`,
    method: 'post',
    data
  })
}

const SaveSeekHelpApplyReceipt = function (data) {//其他救助确认收货
  return request({
    url: `${prefixerForProxy}/SeekHelpApply/ConfirmReceipt`,
    method: 'post',
    data
  })
}

const QuerySickGrantByApplyId = function (params) {//拨款详情
  return request({
    url: `${prefixerForProxy}/SickGrant/QueryByApplyId`,
    method: 'get',
    params
  })
}

const QueryCapitalExpenditure = function (params) {//大病申请查询
  return request({
    url: `${prefixerForProxy}/CapitalExpenditure/Query`,
    method: 'get',
    params
  })
}
const DeleExpendCapitalExpenditure = function (data) {//大资金支出删除
  return request({
    url: `${prefixerForProxy}/CapitalExpenditure/RevokeExpend`,
    method: 'post',
    data
  })
}

const QueryDonationStemCell = function (params) {//造血干细胞查询
  return request({
    url: `${prefixerForProxy}/DonationStemCell/Query`,
    method: 'get',
    params
  })
}

const QueryDonationStemCellById = function (params) {//造血干细胞查询
  return request({
    url: `${prefixerForProxy}/DonationStemCell/QueryById`,
    method: 'get',
    params
  })
}

const UpdateDonationStemCell = function (data) {//编辑造血干细胞
  return request({
    url: `${prefixerForProxy}/DonationStemCell/Update`,
    method: 'post',
    data
  })
}

const ExportDonationStemCell = function (params) {//造血干细胞查询
  return request({
    url: `${prefixerForProxy}/DonationStemCell/ExportDonationStemCell`,
    method: 'get',
    params
  })
}

const SaveDonationStemCell = function (data) {//新增造血干细胞
  return request({
    url: `${prefixerForProxy}/DonationStemCell/SaveDonationStemCell`,
    method: 'post',
    data
  })
}

const QueryDonationOrgan = function (params) {//器官捐赠查询
  return request({
    url: `${prefixerForProxy}/DonationOrgan/Query`,
    method: 'get',
    params
  })
}

const QueryDonationOrganById = function (params) {//器官捐赠查询
  return request({
    url: `${prefixerForProxy}/DonationOrgan/QueryById`,
    method: 'get',
    params
  })
}

const ExportDonationOrgan = function (params) {//器官捐赠导出
  return request({
    url: `${prefixerForProxy}/DonationOrgan/ExportDonationOrgan`,
    method: 'get',
    params
  })
}

const SaveDonationOrgan = function (data) {//保存器官捐赠
  return request({
    url: `${prefixerForProxy}/DonationOrgan/Save`,
    method: 'post',
    data
  })
}

const QueryBacklog = function (params) {//器官捐赠查询
  return request({
    url: `${prefixerForProxy}/Backlog/Query`,
    method: 'get',
    params
  })
}

const SaveImplementProjectImplement = function (data) {//实施项目添加
  return request({
    url: `${prefixerForProxy}/ImplementProject/SaveImplementProject`,
    method: 'post',
    data
  })
}

const QueryImplementProjectImplement = function (params) {//实施项目查询
  return request({
    url: `${prefixerForProxy}/ImplementProject/QueryImplementProject`,
    method: 'get',
    params
  })
}

const QueryApprovalStepById = function (params) {//查询审核步骤
  return request({
    url: `${prefixerForProxy}/ApprovalStep/QueryStepById`,
    method: 'get',
    params
  })
}

const QueryApprovalLogByProcId = function (params) {//查询审核步骤
  return request({
    url: `${prefixerForProxy}/ApprovalLog/QueryByProcId`,
    method: 'get',
    params
  })
}

const AuditDonationStemCell = function (data) {//审核造血干细胞捐献
  return request({
    url: `${prefixerForProxy}/Backlog/AuditDonationStemCell`,
    method: 'post',
    data
  })
}

const AuditDonationOrgan = function (data) {//审核器官捐献
  return request({
    url: `${prefixerForProxy}/Backlog/AuditDonationOrgan`,
    method: 'post',
    data
  })
}

const QueryGroupMemberById = function (params) {//查询团体会员
  return request({
    url: `${prefixerForProxy}/GroupMember/QueryById`,
    method: 'get',
    params
  })
}

const AuditGroupMember = function (data) {//审核团体会员
  return request({
    url: `${prefixerForProxy}/Backlog/AuditGroupMember`,
    method: 'post',
    data
  })
}
const QueryImplementSchedule = function (params) {//查询实施进度
  return request({
    url: `${prefixerForProxy}/ImplementProject/QueryImplementSchedule`,
    method: 'get',
    params
  })
}
const AddScheduleImplementSchedule = function (data) {//查询实施进度
  return request({
    url: `${prefixerForProxy}/ImplementProject/AddSchedule`,
    method: 'post',
    data
  })
}
const DelScheduleImplementSchedule = function (data) {//查询实施进度
  return request({
    url: `${prefixerForProxy}/ImplementProject/DelSchedule`,
    method: 'post',
    data
  })
}

const QueryPersonalMemberById = function (params) {//查询个人会员
  return request({
    url: `${prefixerForProxy}/PersonalMember/QueryById`,
    method: 'get',
    params
  })
}

const AuditPersonalMember = function (data) {//审核个人会员
  return request({
    url: `${prefixerForProxy}/Backlog/AuditPersonalMember`,
    method: 'post',
    data
  })
}

const QueryDonationMaterialsById = function (params) {//查询捐物信息
  return request({
    url: `${prefixerForProxy}/DonationMaterials/QueryDonationMaterialsById`,
    method: 'get',
    params
  })
}

const AuditDonationMaterials = function (data) {//审核物品捐赠
  return request({
    url: `${prefixerForProxy}/Backlog/AuditDonationMaterials`,
    method: 'post',
    data
  })
}

const AuditLifeGuard = function (data) {//审核救护员培训活动
  return request({
    url: `${prefixerForProxy}/Backlog/AuditLifeGuard`,
    method: 'post',
    data
  })
}

const QueryTrainApplyById = function (params) {//查询活动申请
  return request({
    url: `${prefixerForProxy}/TrainApply/QueryById`,
    method: 'get',
    params
  })
}

const AuditLifeGuardApply = function (data) {//审核救护员培训
  return request({
    url: `${prefixerForProxy}/Backlog/AuditLifeGuardApply`,
    method: 'post',
    data
  })
}

const QueryLectureApplyById = function (params) {//查询讲座
  return request({
    url: `${prefixerForProxy}/LectureApply/QueryById`,
    method: 'get',
    params
  })
}

const AuditLectureApply = function (data) {//审核收费讲座培训
  return request({
    url: `${prefixerForProxy}/Backlog/AuditLectureApply`,
    method: 'post',
    data
  })
}

const QueryPublicWelfareById = function (params) {//查询公益项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/QueryById`,
    method: 'get',
    params
  })
}

const AuditPublicWelfare = function (data) {//审核公益项目
  return request({
    url: `${prefixerForProxy}/Backlog/AuditPublicWelfare`,
    method: 'post',
    data
  })
}

const QueryNewsById = function (params) {//查询新闻
  return request({
    url: `${prefixerForProxy}/News/QueryById`,
    method: 'get',
    params
  })
}
const DelScheduleImplementProject = function (data) {// 删除实施进度
  return request({
    url: `${prefixerForProxy}/ImplementProject/DelSchedule`,
    method: 'post',
    data
  })
}

const AuditNews = function (data) {//审核信息发布
  return request({
    url: `${prefixerForProxy}/Backlog/AuditNews`,
    method: 'post',
    data
  })
}

const QueryBigSickApplyById = function (params) {//查询大病申请
  return request({
    url: `${prefixerForProxy}/BigSickApply/QueryById`,
    method: 'get',
    params
  })
}

const ExportBigSickApplyList = function (params) {//查询大病申请
  return request({
    url: `${prefixerForProxy}/BigSickApply/ExportList`,
    method: 'get',
    params
  })
}

const AuditBigSickApply = function (data) {//审核大病申请
  return request({
    url: `${prefixerForProxy}/Backlog/AuditBigSickApply`,
    method: 'post',
    data
  })
}

const QueryBigSickApplyFileByIds = function (params) {//查询大病申请
  return request({
    url: `${prefixerForProxy}/BigSickApply/QueryFileByIds`,
    method: 'get',
    params
  })
}

const QuerySeekHelpApplyById = function (params) {//查询大病申请
  return request({
    url: `${prefixerForProxy}/SeekHelpApply/QueryById`,
    method: 'get',
    params
  })
}

const AuditSeekHelpApply = function (data) {//审核普通救助申请
  return request({
    url: `${prefixerForProxy}/Backlog/AuditSeekHelpApply`,
    method: 'post',
    data
  })
}

const AddProjectExpend = function (data) {//添加项目支出
  return request({
    url: `${prefixerForProxy}/ImplementProject/AddProjectExpend`,
    method: 'post',
    data
  })
}

const QueryImplementExpendById = function (params) {//根据Id查询项目支出列表
  return request({
    url: `${prefixerForProxy}/ImplementProject/QueryImplementExpend`,
    method: 'get',
    params
  })
}

const QueryPublicWelfareByIsHelp = function (params) {//查询求助公益项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/QueryByIsHelp`,
    method: 'get',
    params
  })
}

const QueryPublicWelfareByIsDonation = function (params) {//查询捐赠公益项目
  return request({
    url: `${prefixerForProxy}/PublicWelfare/QueryByIsDonation`,
    method: 'get',
    params
  })
}

const DeleteImplementProject = function (data) {//删除实施项目
  return request({
    url: `${prefixerForProxy}/ImplementProject/DeleteImplementProject`,
    method: 'post',
    data
  })
}

const UpdateImplementProjectStatus = function (data) {//更新实施项目状态
  return request({
    url: `${prefixerForProxy}/ImplementProject/UpdateImplementProjectStatus`,
    method: 'post',
    data
  })
}

const ForReviewImplementProject = function (data) {//实施项目送审
  return request({
    url: `${prefixerForProxy}/ImplementProject/ForReview`,
    method: 'post',
    data
  })
}

const QueryImplementProjectById = function (params) {//根据Id查询实施项目
  return request({
    url: `${prefixerForProxy}/ImplementProject/QueryImplementProjectById`,
    method: 'get',
    params
  })
}

const AuditImplementProject = function (data) {//实施项目审核
  return request({
    url: `${prefixerForProxy}/Backlog/AuditImplementProject`,
    method: 'post',
    data
  })
}

const QueryUsersByRoleType = function (params) {//根据Id查询实施项目
  return request({
    url: `${prefixerForProxy}/Users/QueryByRoleType`,
    method: 'get',
    params
  })
}

const CancelLifeApply = function (data) {//取消体验馆预约
  return request({
    url: `${prefixerForProxy}/LifeApply/CancelLifeApply`,
    method: 'post',
    data
  })
}

const QueryMemberPay = function (params) {//查询会员缴费
  return request({
    url: `${prefixerForProxy}/MemberPay/Query`,
    method: 'get',
    params
  })
}

const QueryApprovalProcessOption = function (params) {//查询审核类型选项
  return request({
    url: `${prefixerForProxy}/ApprovalProcess/GetSelectOption`,
    method: 'get',
    params
  })
}
const PersonalMemberUploadFile = function (data) {//电子文件上传
  return request({
    url: `${prefixerForProxy}/PersonalMember/UploadFile`,
    method: 'post',
    data
  })
}
const PersonalMemberCreateCertPDF = function (params) {//获取文件
  return axios({
    method: 'post',
    url: `${prefixerForProxy}/PersonalMember/CreateCertPDF`,
    params: params,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    responseType: 'blob', //二进制流
  })
}
const PersonalMemberPersonalFile = function (params) {//获取文件
  return request({
    url: `${prefixerForProxy}/PersonalMember/PersonalFile`,
    method: 'get',
    params
  })
}
const DataAnalysisDonationStemCellStatistics = function (params) {//造血干细胞志愿者捐献招募统计
  return request({
    url: `${prefixerForProxy}/DataAnalysis/DonationStemCellStatistics`,
    method: 'get',
    params
  })
}
const DataAnalysisQueryYearStatistics = function (params) {//每年造血干细胞志愿者捐献招募统计
  return request({
    url: `${prefixerForProxy}/DataAnalysis/QueryYearStatistics`,
    method: 'get',
    params
  })
}

const DataAnalysisStatisticsYear = function (params) {//下拉(年份)
  return request({
    url: `${prefixerForProxy}/DataAnalysis/StatisticsYear`,
    method: 'get',
    params
  })
}


const DataAnalysisRescueStatistics = function (params) {//救护员培训情况统计
  return request({
    url: `${prefixerForProxy}/DataAnalysis/RescueStatistics`,
    method: 'get',
    params
  })
}
const DataAnalysisDonationOrganStatistics = function (params) {//器官情况统计
  return request({
    url: `${prefixerForProxy}/DataAnalysis/DonationOrganStatistics`,
    method: 'get',
    params
  })
}

// 志愿活动
const SaveVolunteerRecruit = function(data) {
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/SaveVolunteerRecruit`,
    method: 'post',
    data
  })
}

const DeletedVolunteerRecruitById = function(data) {
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/DeletedVolunteerRecruitById`,
    method: 'post',
    data
  })
}

const ChangeVolunteerRecruitState = function(data) {
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/ChangeVolunteerRecruitState`,
    method: 'post',
    data
  })
}

const GenerateSignQrCode = function(data) {
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/GenerateSignQrCode`,
    method: 'post',
    data
  })
}

const QueryVolunteerRecruit = function (params) {
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/QueryVolunteerRecruit`,
    method: 'get',
    params
  })
}

const GetActivityTypeList = function (params) {//获取志愿者活动类型
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/GetActivityTypeList`,
    method: 'get',
    params
  })
}

const SaveActivityType = function(data) {//更新志愿者活动类型
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/SaveActivityType`,
    method: 'post',
    data
  })
}

const DeletedActivityTypeById = function(data) {//更新志愿者活动类型
  return request({
    url: `${prefixerForProxy}/VolunteerRecruit/DeletedActivityTypeById`,
    method: 'post',
    data
  })
}

//志愿者活动申请
const QueryApplyVolunteerRecruit = function (params) {//获取志愿者活动类型
  return request({
    url: `${prefixerForProxy}/VolunteerRecruitApply/QueryApplyVolunteerRecruit`,
    method: 'get',
    params
  })
}

//志愿者申请
const QueryApplyVolunteer = function (params) {//志愿者信息列表查询
  return request({
    url: `${prefixerForProxy}/VolunteerApply/QueryApplyVolunteer`,
    method: 'get',
    params
  })
}

const exportVolunteer = function (params) {//志愿者信息列表查询
  return request({
    url: `${prefixerForProxy}/VolunteerApply/ExportVolunteer`,
    method: 'get',
    params
  })
}

const QueryApplyVolunteerByUserId = function (params) {//获取志愿者活动类型
  return request({
    url: `${prefixerForProxy}/VolunteerApply/QueryApplyVolunteerByUserId`,
    method: 'get',
    params
  })
}

//志愿者活动签到
const QuerySignByUserId = function (params) {//获取志愿者活动类型
  return request({
    url: `${prefixerForProxy}/VolunteerRecruitSign/QuerySignByUserId`,
    method: 'get',
    params
  })
}

const saveVolunteerRecruitSignByAdmin = function(data) {//更新志愿者活动类型
  return request({
    url: `${prefixerForProxy}/VolunteerRecruitSign/saveByAdmin`,
    method: 'post',
    data
  })
}


const QueryApplyVolunteerById = function(params) {
  return request({
    url: `${prefixerForProxy}/VolunteerApply/QueryApplyVolunteerById`,
    method: 'get',
    params
  })
}

const AuditVolunteerApply = function (data) {//审核造血干细胞捐献
  return request({
    url: `${prefixerForProxy}/Backlog/AuditVolunteerApply`,
    method: 'post',
    data
  })
}

const AuditLifeGuardApplyPay = function (data) {
  return request({
    url: `${prefixerForProxy}/Backlog/AuditLifeGuardApplyPay`,
    method: 'post',
    data
  })
}

const ExportVolunteerRecruitApply = function(params) {
  return request({
    url: `${prefixerForProxy}/VolunteerRecruitApply/ExportSign`,
    method: 'get',
    params
  })
}

const QueryRescueActivity = function(params) {
  return request({
    url: `${prefixerForProxy}/RescueActivity/GetList`,
    method: 'get',
    params
  })
}

const SaveRescueActivity = function (data) {
  return request({
    url: `${prefixerForProxy}/RescueActivity/SaveRescueActivity`,
    method: 'post',
    data
  })
}

const DeleteRescueActivityById = function (data) {
  return request({
    url: `${prefixerForProxy}/RescueActivity/DeletedById`,
    method: 'post',
    data
  })
}

const UpdateState = function (data) {
  return request({
    url: `${prefixerForProxy}/SeekHelpApply/UpdateState`,
    method: 'post',
    data
  })
}
const GetFileDetail = function(params) {
  return request({
    url: `${prefixerForProxy}/File/GetFileDetail`,
    method: 'get',
    params
  })
}

const exportMember = function(params) {
  return request({
    url: `${prefixerForProxy}/PersonalMember/QueryToExcel`,
    method: 'get',
    params
  })
}
const QueryPersonalCertificate = (params) => { // 个人会员证书
  return request({
    url: `${prefixerForProxy}/PersonalMember/CreateCertificate`,
    method: 'get',
    responseType: 'blob',
    params
  })
}
const QueryGroupCertificate = (params) => { // 团体会员证书
  return request({
    url: `${prefixerForProxy}/GroupMember/CreateCertificate`,
    method: 'get',
    responseType: 'blob',
    params
  })
}

const GetMemberTree = (params) => {
  return request({
    url: `${prefixerForProxy}/PersonalMember/GetMemberTree`,
    method: 'get',
    params
  })
}

const AddMemberPay = (data) => {
  return request({
    url: `${prefixerForProxy}/MemberPay/AddMemberPay`,
    method: 'post',
    data
  })
}

const getCloudSmsList = function (params) { // 云端短信列表
  return request({
    url: `${prefixerForProxy}/CloudSms/GetList`,
    method: 'get',
    params
  })
}

const getUserGroupsList = function (params) { // 云端短信群组列表
  return request({
    url: `${prefixerForProxy}/CloudSms/GetUserGroupsList`,
    method: 'get',
    params
  })
}

const saveCloudSms = function (data) { // 新增 && 保存云短信
  return request({
    url: `${prefixerForProxy}/CloudSms/SaveCloudSms`,
    method: 'post',
    data
  })
}

const getCloudSmsDetailList = function (params) { // 云端短信明细列表
  return request({
    url: `${prefixerForProxy}/CloudSms/GetCloudSmsDetailList`,
    method: 'get',
    params
  })
}

const getCloudSmsById = function (params) { // 查询云端短信
  return request({
    url: `${prefixerForProxy}/CloudSms/QueryById`,
    method: 'get',
    params
  })
}

const sendCloudSms = function (data) { // 新增 && 保存云短信
  return request({
    url: `${prefixerForProxy}/CloudSms/SendMessage`,
    method: 'post',
    data
  })
}

const deleteCloudSms = function (data) { // 新增 && 保存云短信
  return request({
    url: `${prefixerForProxy}/CloudSms/DeletedCloudSmsByIds`,
    method: 'post',
    data
  })
}

const queryVisitor = function(params) {
  return request({
    url: `${prefixerForProxy}/Visitor/QueryVisitor`,
    method: 'get',
    params
  })
}

const getVisitorCount = function(params) {
  return request({
    url: `${prefixerForProxy}/Visitor/GetVisitorCount`,
    method: 'get',
    params
  })
}

const exportDonation = function(params) {
  return request({
    url: `${prefixerForProxy}/Donation/ExportDonation`,
    method: 'get',
    params
  })
}

// InstationSet
const queryStationSet = function(params) {
  return request({
    url: `${prefixerForProxy}/InstationSet/QueryStationSet`,
    method: 'get',
    params
  })
}

const queryStationSetDetail = function(params) {
  return request({
    url: `${prefixerForProxy}/InstationSet/QueryStationSetDetail`,
    method: 'get',
    params
  })
}

const saveStationSet = function(data) {
  return request({
    url: `${prefixerForProxy}/InstationSet/SaveInstationSetting`,
    method: 'post',
    data
  })
}

// InstationMessage
const queryStationMessage = function (params) {
  return request({
    url: `${prefixerForProxy}/InstationMessage/QueryInstationMessage`,
    method: 'get',
    params
  })
}

const queryStationMessageDetail = function (params) {
  return request({
    url: `${prefixerForProxy}/InstationMessage/QueryById`,
    method: 'get',
    params
  })
}

const setInstationRead = function (data) {
  return request({
    url: `${prefixerForProxy}/InstationMessage/SetRead`,
    method: 'post',
    data
  })
}

// 一体机接口

const QuerySlideSetting= function (params) {//查询banner图片
  return request({
    url: `${prefixerForProxy}/banner/list`,
    method: 'get',
    params
  })
}

const SaveSlideSetting = function (data) {//新增banner图片
  return request({
    url: `${prefixerForProxy}/banner/save`,
    method: 'post',
    data
  })
}
// const GetEmployee= function (params) { // 获取管理人员
//   return request({
//     url: `${prefixerForProxy}/Employee/GetEmployee`,
//     method: 'get',
//     params
//   })
// }
const DeleteSlideSettingById = (data) => { // 删除banner图片
  return request({
    url: `${prefixerForProxy}/banner/delete`,
    method: 'post',
    data
  })
}
const DeleteSlideSettingInBatches = (data) => { // 批量删除banner图片
  return request({
    url: `${prefixerForProxy}/SlideSetting/DeleteInBatches`,
    method: 'post',
    data
  })
}

const SaveContactSlide = function (data) {//新增banner图片
  return request({
    url: `${prefixerForProxy}/ContactUsSlide/Save`,
    method: 'post',
    data
  })
}
const QueryContactSlide= function (params) {//查询banner图片
  return request({
    url: `${prefixerForProxy}/ContactUsSlide/Query`,
    method: 'get',
    params
  })
}
const DeleteContactSlideById = (data) => { // 删除banner图片
  return request({
    url: `${prefixerForProxy}/ContactUsSlide/DeleteById`,
    method: 'post',
    data
  })
}
const DeleteContactSlideInBatches = (data) => { // 批量删除banner图片
  return request({
    url: `${prefixerForProxy}/ContactUsSlide/DeleteInBatches`,
    method: 'post',
    data
  })
}

const SaveEquipment = function (data) {
  return request({
    url: `${prefixerForProxy}/Equipment/SaveEquipment`,
    method: 'post',
    data
  })
}

const QueryEquipment = function (params) {
  return request({
    url: `${prefixerForProxy}/Equipment/QueryEquipment`,
    method: 'get',
    params
  })
}

const GetEquipment = function (params) {
  return request({
    url: `${prefixerForProxy}/Equipment/GetEquipment`,
    method: 'get',
    params
  })
}

const DeleteEquipment = function (data) {
  return request({
    url: `${prefixerForProxy}/Equipment/DeleteHEquipment`,
    method: 'post',
    data
  })
}

//首页设置
const SaveHomeSetting = function (data) {
  return request({
    url: `${prefixerForProxy}/home/setting/save`,
    method: 'post',
    data
  })
}

const QueryHomeSetting = function (params) {
  return request({
    url: `${prefixerForProxy}/home/setting/list`,
    method: 'get',
    params
  })
}
const PublishHomeSetting = function (data) {
  return request({
    url: `${prefixerForProxy}/home/setting/update/status`,
    method: 'post',
    data
  })
}

const CancelPublishHomeSetting = function (data) {
  return request({
    url: `${prefixerForProxy}/HomeSetting/CancelPublishHomeSetting`,
    method: 'post',
    data
  })
}

const Preview = function (params) {
  return request({
    url: `${prefixerForProxy}/HomeSetting/Preview`,
    method: 'get',
    params
  })
}
const DeleteHomeSetting = function (data) {
  return request({
    url: `${prefixerForProxy}/home/setting/delete`,
    method: 'post',
    data
  })
}
// 设备参数
const GetFeatureSetting = function (params) {
  return request({
    url: `${prefixerForProxy}/feature/setting/info`,
    method: 'get',
    params
  })
}
const SaveFeatureSetting = function (data) {
  return request({
    url: `${prefixerForProxy}/feature/setting/save`,
    method: 'post',
    data
  })
}
const FileUpload = `${prefixerForProxy}/File/FileUpload`

const DeleteExpend = function(data) {
  return request({
    url: `${prefixerForProxy}/expend/delete`,
    method: 'post',
    data
  })
}

const ExportExpend = function (params) {
  return request({
    url: `${prefixerForProxy}/expend/export`,
    method: 'get',
    params
  })
}

const ExpendDetail = function (params) {
  return request({
    url: `${prefixerForProxy}/expend/detail`,
    method: 'get',
    params
  })
}

const ImportExpend = function (data) {
  return request({
    url: `${prefixerForProxy}/expend/import`,
    method: 'post',
    data
  })
}

const ExpendList = function (params) {
  return request({
    url: `${prefixerForProxy}/expend/list`,
    method: 'get',
    params
  })
}

const SaveExpend = function (data) {
  return request({
    url: `${prefixerForProxy}/expend/save`,
    method: 'post',
    data
  })
}

const ExpendBatchSet = function (data) {
  return request({
    url: `${prefixerForProxy}/expend/batch/set`,
    method: 'post',
    data
  })
}

const ExpendSet = function (data) {
  return request({
    url: `${prefixerForProxy}/expend/set`,
    method: 'post',
    data
  })
}

const QueryOpLog = function (params) {
  return request({
    url: `${prefixerForProxy}/log/op/list`,
    method: 'get',
    params
  })
}

const QueryExLog = function (params) {
  return request({
    url: `${prefixerForProxy}/log/ex/list`,
    method: 'get',
    params
  })
}


export default{
  QueryExLog,
  QueryOpLog,
  DeleteExpend,
  ExportExpend,
  ExpendDetail,
  ImportExpend,
  ExpendList,
  SaveExpend,
  ExpendBatchSet,
  ExpendSet,
  SaveContactSlide,
  QueryContactSlide,
  DeleteContactSlideById,
  DeleteContactSlideInBatches,
  FileUpload,
  SaveHomeSetting,
  QueryHomeSetting,
  PublishHomeSetting,
  CancelPublishHomeSetting,
  Preview,
  DeleteHomeSetting,
  SaveSlideSetting,
  QuerySlideSetting,
  SaveEquipment,
  QueryEquipment,
  GetEquipment,
  DeleteEquipment,
  DeleteSlideSettingById,
  DeleteSlideSettingInBatches,
  GetFeatureSetting,
  SaveFeatureSetting,




  queryStationMessage,
  queryStationMessageDetail,
  queryStationSetDetail,
  setInstationRead,
  queryStationSet,
  saveStationSet,
  exportDonation,
  getVisitorCount,
  queryVisitor,
  getCloudSmsById,
  deleteCloudSms,
  sendCloudSms,
  getCloudSmsDetailList,
  saveCloudSms,
  getUserGroupsList,
  getCloudSmsList,
  AddMemberPay,
  GetMemberTree,
  exportMember,
  ExportBigSickApplyList,
  GetFileDetail,
  UpdateState,
  ExportDonationOrgan,
  ExportDonationStemCell,
  SaveDonationStemCell,
  DeleteRescueActivityById,
  SaveRescueActivity,
  QueryRescueActivity,
  ExportVolunteerRecruitApply,
  AuditLifeGuardApplyPay,
  AuditVolunteerApply,
  QueryApplyVolunteerById,
  saveVolunteerRecruitSignByAdmin,
  exportVolunteer,
  QueryApplyVolunteer,
  QuerySignByUserId,
  QueryApplyVolunteerByUserId,
  QueryApplyVolunteerRecruit,
  GenerateSignQrCode,
  ChangeVolunteerRecruitState,
  DeletedVolunteerRecruitById,
  DeletedActivityTypeById,
  SaveActivityType,
  GetActivityTypeList,
  SaveVolunteerRecruit,
  QueryVolunteerRecruit,
  QueryNewsType,
  getNewsTypeOptions,
  SaveNewsType,
  DeleteNewsTypeById,
  SelectNewsTypeById,
  SaveNews,
  QueryNews,
  UpdateNewsTopById,
  SendNewsBacklog,
  RecallNews,
  UpdateNewsStatus,
  DeleteNewsById,
  QuerySiteMenu,
  QueryDomainPrefix,
  DeleteNewsInBatches,
  DeleteSiteMenu,
  SaveSiteMenu,
  SavenewMenu,
  loadMenuJsTreeNodes,
  nodeMenuMove,
  getMenuDir,
  saveMenuDir,
  loadMenuJsTreeChildren,
  QueryConnection,
  DeleteConnection,
  saveConnection,
  QuerySlideShow,
  saveSlideShow,
  QueryApprovalProcess,
  saveApprovalProcess,
  QueryApprovalStep,
  QueryUsers,
  UpdateUser,
  DeleteUser,
  SaveUser,
  ResetUserPassword,
  QueryPersonalMember,
  QueryGroupMember,
  UpdatePersonalMemberStatus,
  SavePersonalMember,
  SaveGroupMember,
  UpdateGroupMemberStatus,
  QueryPublicWelfare,
  DeletePublicWelfare,
  UpdatePublicWelfareStatus,
  QueryWelfareIndex,
  UpdatePublicWelfareIsHelp,
  QueryProjectType,
  QueryConnectionName,
  SavePublicWelfare,
  SavePublicWelfareReview,
  QueryStepById,
  QueryStepByProcId,
  QueryDonation,
  UpdateContriButionStatus,
  DeleteContriBution,
  QueryTimeToDonationList,
  QueryTimeToDonation,
  QueryPublicWelfareAll,
  SaveContriBution,
  QueryDonationMaterials,
  QueryMaterialsDetailById,
  UpdateMaterialsReceiving,
  SaveDonationMateials,
  DeleteDonationMaterials,
  QueryInvoiceApply,
  UpdateInvoiceApply,
  QueryTrainByType,
  QueryTrainById,
  UpdateTrainStatus,
  DeleteTrainById,
  SaveTrain,
  ForReviewTrain,
  QueryLifeGuard,
  QueryLifeGuardDetail,
  //QueryCapitalExpenditure,
  //GetCapialIndexCapitalExpenditure,
  QueryPersonalTrainByApplyId,
  QueryTrainApplyByClassId,
  QueryTrainClassByClass,
  SaveTrainClass,
  DeleteTrainClassStu,
  SaveTrainClassStu,
  UpdateTrainClassIsClassed,
  QuerylifeGuard,
  QueryCapitalIncome,
  GetIncomeIndexCapitalIncome,
  SaveCapitalIndexCapitalIncome,
  TransfertoClass,
  SaveTrainClassByAutoClass,
  QueryLectureApplyByType,
  UpdateLectureIsAttended,
  QueryLibraryPeriods,
  QueryAllTrainByType,
  SaveLibraryPeriods,
  QueryLifeApplyByPeriods,
  QueryLifeApplyCount,
  QueryLifePersonByApplyId,
  UpdateLifePersonIsAttended,
  UpdateLifePersonIsAttendedByApplyId,
  DeleteIncome,
  QueryBigSickApply,
  SaveSickGrant,
  QuerySeekHelpApply,
  SaveSeekHelpApplyReceipt,
  QuerySickGrantByApplyId,
  AddExpendCapitalExpenditure,
  QueryCapitalExpenditure,
  DeleExpendCapitalExpenditure,
  QueryDonationStemCell,
  QueryDonationStemCellById,
  UpdateDonationStemCell,
  QueryDonationOrgan,
  QueryDonationOrganById,
  SaveDonationOrgan,
  QueryBacklog,
  SaveImplementProjectImplement,
  QueryImplementProjectImplement,
  QueryApprovalStepById,
  QueryApprovalLogByProcId,
  AuditDonationStemCell,
  AuditDonationOrgan,
  QueryGroupMemberById,
  AuditGroupMember,
  QueryPersonalMemberById,
  AuditPersonalMember,
  QueryDonationMaterialsById,
  AuditDonationMaterials,
  AuditLifeGuard,
  QueryTrainApplyById,
  AuditLifeGuardApply,
  QueryLectureApplyById,
  AuditLectureApply,
  QueryPublicWelfareById,
  AuditPublicWelfare,
  QueryImplementSchedule,
  AddScheduleImplementSchedule,
  QueryNewsById,
  DelScheduleImplementSchedule,
  DelScheduleImplementProject,
  AuditNews,
  QueryBigSickApplyById,
  AuditBigSickApply,
  QueryBigSickApplyFileByIds,
  QuerySeekHelpApplyById,
  AuditSeekHelpApply,
  AddProjectExpend,
  QueryImplementExpendById,
  QueryPublicWelfareByIsHelp,
  DeleteImplementProject,
  UpdateImplementProjectStatus,
  ForReviewImplementProject,
  QueryImplementProjectById,
  AuditImplementProject,
  QueryUsersByRoleType,
  CancelLifeApply,
  QueryPublicWelfareByIsDonation,
  QueryMemberPay,
  QueryApprovalProcessOption,
  PersonalMemberUploadFile,
  PersonalMemberCreateCertPDF,
  PersonalMemberPersonalFile,
  DataAnalysisRescueStatistics,
  DataAnalysisDonationStemCellStatistics,
  DataAnalysisDonationOrganStatistics,
  DataAnalysisStatisticsYear,
  DataAnalysisQueryYearStatistics,
  UpdatePaymentstatusPersonal,
  UpdatePaymentstatusGroup,
  QueryPersonalCertificate,
  QueryGroupCertificate
}
